// Task row column count/widths — shared between the antd `taskColumns`
// config (TasksTableGrid.tsx) and the task row's own layout (TaskSummaryRow),
// so both sides of the grid agree on how many columns a task row spans and
// how wide each one is.
export const TASK_ROW_COLUMN_COUNT = 6;

// The value columns have fixed widths sized to what they hold, and the Task
// column takes all the remaining width (OP-2534) — previously every column
// was a share of the width, so on a wide screen $/ha, Area and Area unit
// spread far apart. The task's own Water rate / Target controls use the
// extra room, wrapping beneath the task name when it runs out.
export const TASK_ROW_COLUMN_WIDTHS_REM = {
  date: 9,
  timing: 10,
  area: 4.5,
  areaUnit: 5,
  // Seats the row's three-dot button beside the cost.
  cost: 7.5,
};

/**
 * The Task column stops shrinking here and the grid scrolls instead. Mirrors
 * the `.input-tasks-table` table min-width in App.css (16 + the columns above).
 */
export const TASK_COLUMN_MIN_WIDTH_REM = 16;

export const TASK_ROW_WIDTHS = Object.fromEntries(
  Object.entries(TASK_ROW_COLUMN_WIDTHS_REM).map(([key, value]) => [
    key,
    `${value}rem`,
  ])
) as Record<keyof typeof TASK_ROW_COLUMN_WIDTHS_REM, string>;
